import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

export default function Footer() {
    const navigationLinks = [
        // { label: "About", href: "/about" },
        { label: "Works", href: "/works" },
        { label: "AI Platform", href: "/ai-platform" },
        { label: "Contact", href: "/contact" }
    ];

    const socialLinks = [
        {
            label: "LinkedIn",
            href: "https://www.linkedin.com/company/bold-edge-media/",
            external: true
        },
        {
            label: "Youtube",
            href: "https://www.youtube.com/@BoldEdgeMedia",
            external: true
        },
        {
            label: "Instagram",
            href: "https://www.instagram.com/boldedgemedia__",
            external: true
        }
    ];

    return (
        <footer className=" text-white z-[20] relative  border-gray-900 ">
            <div className="container mx-auto px-4 py-24 pb-12">
                {/* Main footer content */}
                <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8 lg:gap-4">

                    {/* Logo section */}
                    <div className="flex-shrink-0">
                        <div className="flex-shrink-0">
                            <Link to="/" >
                                <img className="w-14 sm:w-20 lg:w-20 h-auto" src="/logo/logo-1.png" alt="Logo" />
                            </Link>
                        </div>
                        {/* Copyright */}
                        <p className="text-sm text-white mt-2 lg:mt-4">
                            © 2025 Bold Edge Media
                        </p>
                    </div>

                    {/* Navigation Links */}
                    <div className="flex flex-wrap gap-6 sm:gap-8 lg:gap-12  lg:justify-center flex-1">
                        {navigationLinks.map((link, index) => (
                            <Link
                                key={index}
                                to={link.href}
                                className="text-white hover:text-brand-orange transition-colors duration-200 font-medium"
                            >
                                {link.label}
                            </Link>
                        ))}
                    </div>

                    {/* Social Links */}
                    <div className="flex flex-col gap-3 lg:items-end">
                        {socialLinks.map((link, index) => (
                            <a
                                key={index}
                                href={link.href}
                                target={link.external ? "_blank" : undefined}
                                rel={link.external ? "noopener noreferrer" : undefined}
                                className="flex items-center gap-2 text-white hover:text-brand-orange transition-colors duration-200 group"
                            >
                                <span className="font-medium">{link.label}</span>
                                <ArrowRight
                                    size={14}
                                    strokeWidth={2.5}
                                    className="transform -rotate-45 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-200"
                                />
                            </a>
                        ))}
                    </div>
                </div>
            </div>
        </footer>
    );
}